import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el PROFEPACK después de comprar?',
    a: 'Al confirmar el pago recibís un email con acceso inmediato a todos los PDFs. En menos de 5 minutos ya podés abrir el primer tomo.'
  }, {
    q: '¿Sirve para mi provincia o solo para Buenos Aires?',
    a: 'Sirve para todo el país. El MegaPack está alineado al diseño curricular argentino 2026 que es la base de todas las jurisdicciones. Muchos docentes lo adaptan fácilmente a su planificación institucional.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'Es en formato PDF listo para usar tal cual. Podés imprimirlo o usarlo desde cualquier dispositivo. Si necesitás adaptar alguna consigna, podés hacerlo en cualquier editor de PDF básico.'
  }, {
    q: '¿Los 6 bonos están en todas las ofertas?',
    a: 'Sí. Los 6 bonos están incluidos en las 3 opciones (Primaria, Secundaria y Pack Completo) sin costo extra.'
  }, {
    q: '¿Puedo comprar Primaria ahora y Secundaria después?',
    a: 'Sí. Podés empezar con el nivel que más usás hoy y sumar el otro después. Aunque el Pack Completo es la opción más conveniente (ahorrás $5.000).'
  }, {
    q: '¿Funciona si tengo cursos difíciles o con mucho desorden?',
    a: 'Sí. Las secuencias tienen activadores cortos y estructuras claras que ayudan a ordenar el grupo desde el inicio de la clase. El Bono de Pizarra & Slides Pro también ayuda en ese sentido.'
  }, {
    q: '¿Está actualizado al currículo vigente?',
    a: 'Sí. Está adaptado al diseño curricular argentino 2026 para primaria y secundaria.'
  }, {
    q: '¿Qué pasa si no tengo acceso a internet en la escuela?',
    a: 'Una vez descargados los PDFs los tenés para siempre en tu dispositivo sin necesitar conexión.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días completos. Si no es lo que esperabas, te devolvemos el 100% sin preguntas.'
  }, {
    q: '¿Qué diferencia tiene PROFEPACK con otros packs que vi?',
    a: 'La mayoría de los materiales son actividades sueltas. PROFEPACK es un sistema: secuencia + consignas + evaluación + bonos de implementación, todo pensado para que lo uses desde mañana sin adaptar nada.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="cv-auto bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-78">
          ❓ PREGUNTAS <span className="text-brand-accent" data-id="element-79">FRECUENTES</span>
        </h2>
        <div className="space-y-4" data-id="element-80">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-card rounded-2xl border border-brand-border overflow-hidden" data-id="element-81">
              <button className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-82">
                <span className="font-bold text-white text-lg pr-8" data-id="element-83">
                  <span className="text-brand-accent mr-2" data-id="element-84">{i + 1} —</span>{' '}
                  {faq.q}
                </span>
                <span className={`text-brand-accent text-2xl flex-shrink-0 transition-transform duration-300 leading-none ${openIndex === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-85">
                  ▾
                </span>
              </button>
              {openIndex === i && <div role="region" data-id="element-86">
                  <div className="px-8 pb-8 text-white/80 border-t border-brand-border pt-6 text-lg leading-relaxed" data-id="element-87">
                    {faq.a}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}